import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const env = process.env;

/**
 *
 * @type {{apiKey: string, authDomain: string, databaseURL: string, projectId: string, storageBucket: string, messagingSenderId: string}}
 */
const config = {
  apiKey: env.FIREBASE_API_KEY,
  authDomain: env.FIREBASE_AUTH_DOMAIN,
  databaseURL: env.FIREBASE_DATABASE_URL,
  projectId: env.FIREBASE_PROJECT_ID,
  storageBucket: env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.FIREBASE_MESSAGING_SENDER_ID
};
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
db.settings({
  timestampsInSnapshots: true // date issue fix according to firebase
});

const auth = firebase.auth();

// firebase collections
const usersCollection = db.collection('users')
const slidesCollection = db.collection('slides');
const countriesCollection = db.collection('countries');
const ordersCollection = db.collection('orders');

export {
  firebase,
  db,
  auth,
  usersCollection,
  countriesCollection,
  slidesCollection,
  ordersCollection
}



// WEBPACK FOOTER //
// ./src/firebase/index.js